import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent } from 'core/components'
import { Button, Row, Col } from 'core/components/Framework7';
import { getCart } from 'content/pages/Cart/Module';

import classes from './styles.module.css';

class OrderComplete extends PureComponent {
  constructor(props) {
    super(props);

    const view = this.$f7.views.get('#view-cart')
    this.router = view && view.router

    this.state = { }
  }

  componentDidMount() {
    this.props.getCart({ store: 2 })
  }

  get data() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.orderStepsComplete,
    }
  }

  handleNext() {
    window.location.reload()
  }

  render() {
    const { order } = this.props

    return (
      <div className={classes.container}>
        {/* <div className={classes.buyCompleteTXT}>
          <p>
            {'کد پیگیری شما‌: '}{this.props.order ? this.props.order.trackingCode : null}
          </p>
          <p>
            {'شما می‌توانید از بخش حساب کاربری و سپس سفارشات من، وضعیت سفارش خود را بررسی کنید.'}
          </p>
        </div> */}

        <div className={classes.trackingContainer}>
          <div className={classes.trackingBox}>
            <Row>
              <span>
                {'کد پیگیری'}
              </span>
            </Row>
            <Row className={classes.trackingCode}>
              {order ? order.trackingCode : '-'}
            </Row>
          </div>
        </div>

        {/* Message */}
        <div className={classes.descriptionBox}>
          {this.data.page.description.map((text, index) => {
            return <p key={index}>{text}</p>
          })}
        </div>

        {/* <img src={DeliveryImage} className={classes.deliveryImage} /> */}
        <div className={classes.deliveryImage} />

        <div className={classes.finishStepButtonContainer}>
          <Button large outline fill
            text={'اتمام خرید'}
            icon='mdi-check'
            className={`${classes.finishStepButton}`}
            onClick={this.handleNext}
          />
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    order: state.Order.order,
  }),
  {
    getCart
  }
)(autobind(OrderComplete))